import { TripOnboardingModal } from './TripOnboarding'

export default TripOnboardingModal
